<template>
  <div class="p-4">
    <button @click="createCategory" class="float-right border-2 border-blue-500 text-blue-500 font-bold py-2 px-4 mb-6 rounded">
      New Category
    </button>
    <el-table
      :data="categories"
      :empty-text="'No Category available'"
      :default-sort = "{prop: 'id', order: 'ascending'}"
      style="width: 100%">
      <el-table-column
        prop="name"
        label="Name">
      </el-table-column>
      <el-table-column
        prop="homepage_feature"
        align="center"
        label="Show on Homepage">
        <template slot-scope="scope">
          <span v-if="scope.row.homepage_feature === true"><el-tag size="small" type="success">Yes</el-tag></span>
          <span v-else><el-tag size="small" type="danger">No</el-tag></span>
        </template>
      </el-table-column>
      <el-table-column
        prop="image"
        label="Image Link">
        <template slot-scope="scope">
          <a class="text-xs text-blue-500 italic hover:underline cat-img" v-if="scope.row.image" :href="scope.row.image" target="_blank">
            <img :src=scope.row.image>
          </a>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="Operations">
        <template slot-scope="scope">
          <el-button @click="viewDetails(scope.row.id)" type="text" size="small">
            <i class="text-sm text-gray-500 el-icon-view mr-1"></i>
          </el-button>
          <el-button @click="update(scope.row)" type="text" size="small">
            <i class="text-sm el-icon-edit mr-1"></i>
          </el-button>
          <el-button @click="deleteCategory(scope.row.id)" type="text" size="small">
            <i class="text-sm text-red-500 el-icon-delete-solid"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <NewCategoryForm @imageUpload="imageUpload" />
    <CategoryUpdateForm :upload_url="url" />
  </div>
</template>

<script>
import NewCategoryForm from './_includes/Category/CreateForm.vue';
import CategoryUpdateForm from './_includes/Category/UpdateForm.vue';

export default {
  name: 'Category',
  components: {
    NewCategoryForm,
    CategoryUpdateForm,
  },
  data() {
    return {
      newCategoryId: '',
      url: '',
    };
  },
  computed: {
    categories() {
      return this.$store.state.InventoryModule.Catalog.categories;
    },
  },
  methods: {
    createCategory() {
      this.$modal.show('new-category');
    },
    update(category) {
      this.url = `${process.env.VUE_APP_ECOMMERCE_BASE_API}/merchant/catalog/${category.id}/images?type=categories`;
      this.$store.commit('InventoryModule/Catalog/setCurrentSelected', { property: 'category', payload: category });
      this.$modal.show('update-category');
    },
    viewDetails(id) {
      this.$router.push(`/ecommerce/inventory/category/${id}/subcategory`);
    },
    imageUpload(id) {
      this.$modal.hide('new-category');
      this.$modal.show('image-upload');

      this.url = `${process.env.VUE_APP_ECOMMERCE_BASE_API}/merchant/catalog/${id}/images?type=categories`;
    },
    deleteCategory(categoryId) {
      this.$confirm('This will permanently delete the category, all sub-categories and micro-categories under it. Continue?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning',
      }).then(async () => {
        try {
          await this.$store.dispatch('InventoryModule/Catalog/deleteCategory', categoryId);
          this.$notify.success({
            title: 'Success',
            message: 'Category successfully deleted',
          });
        } catch (e) {
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong please try again.',
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
  .cat-img img {
    height: 50px;
    width: 70px;
    border-radius: 4px;
    object-fit: cover;
  }
</style>
